import styled from 'styled-components';

const Forecast = styled.section`
  display: flex;
  flex-wrap: wrap;

  .observer-container {
    position: relative;
    display: flex;
    align-items: center;
    overflow-x: scroll;
    overflow-y: hidden;
    overflow: scroll;
  }

  .observed-item {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin: 1rem;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 5px;
    padding: 1rem;

    p {
      margin: 0.3rem;
      color: white;
      font-family: 'Concert One';
    }
  }
`;

export default Forecast